var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"toast",style:({ width: _vm.isWordsLong ? '55%' : '' })},[_c('div',{staticClass:"text",style:({ fontSize: _vm.isWordsLong ? '12px' : '16px' })},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }